import {List} from "@/models/List";
import {formatDateToText} from "@/scripts";

export class ApplicationDtoList extends List{
  constructor(obj) {
    super(ApplicationDto, obj)
  }
}

export class ApplicationDto {
  constructor(obj = {}) {
    this.id = obj?.id || null
    this.fullName = obj?.fullName || null
    this.applicationStatus = obj?.applicationStatus || null
    this.applicationType = obj?.applicationType || null
    this.specialityTo = obj?.specialityTo || null
    this.courseNumberTo = obj?.courseNumberTo || null
    this.paidFormTo = obj?.paidFormTo || null
    this.sendDateTime = obj?.sendDateTime || null
  }

  get applicationStatusText() {
    return this.applicationStatus?.name || ''
  }

  get applicationTypeText() {
    return this.applicationType?.name || ''
  }

  get specialityToText() {
    return this.specialityTo?.name || ''
  }

  get courseNumberToText() {
    return this.courseNumberTo?.name || ''
  }

  get paidFormToText() {
    return this.paidFormTo?.name || ''
  }

  get sendDateTimeText() {
    return this.sendDateTime ? formatDateToText(this.sendDateTime) : ''
  }
}
